export enum Situacoes {
    Inativo = 1,
    Ativo = 2,
    "Em Análise" = 3,
    Autorizado = 4
};

export enum Status {
    "Em Análise" = 1,
    Aprovado = 2,
    Recusado = 3,
    Excluido = 4
};

export enum StatusFiltro {
    "Em Análise" = 1,
    "Aprovado" = 2,
    "Recusado" = 3,
    "Excluído" = 4
};

export enum CotaParte {
    Sim = 1,
    "Não" = 0
};

export enum Especies {
    Anuidade = 1,
    Taxa = 2,
    MultaInfracao = 3,
    MultaEleicao = 4,
    DescontoAnuidade = 5
};

export enum Sistemas {
    "Acessos" = 1,
    "EPC" = 2,
    "Arrecadação" = 3,
    "Registro" = 4,
    "CRE" = 5,
}

export enum TipoUsuario {
    Interno = 1,
    Externo = 2
}


// WEBPACK FOOTER //
// ./src/app/entity/enumeraveis.ts